<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          >
            <CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar
          </a>
        </div>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Subcategoria' : 'Cadastrar Subcategoria' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <label class="mb-0">
                    <b>Status</b>
                  </label>

                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <!-- Category -->
                  <CCol lg="6">
                    <div class="form-group">
                      <label for="">Categoria*</label>

                      <Multiselect
                        :value="categoriesOptions.find(option => option.value == form.category_id)"
                        :options="categoriesOptions"
                        label="label"
                        track-by="value"
                        placeholder="Categoria"
                        :disabled="processing"
                        @select="(selected) => form.category_id = selected.value"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>

                  <!-- Title -->
                  <CCol lg="6">
                    <CInput
                      v-model="form.title"
                      label="Título*"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="products-subcategory"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>

                  <CCol
                    col="12"
                  >
                    <Seo
                      :form="form.seo"
                      :page-title="form.title"
                      :page-description="form.description"
                      :is-edit="!!$route.params.id"
                    />
                  </CCol>
                </CRow>
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="products-subcategory"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.description_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="products-subcategory"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.description_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import Seo from '@/components/ui/Seo'
import TabsStatus from '@/components/ui/TabsStatus'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

// Services
import Service from '@/services/product-subcategory.service'
import CategoryService from '@/services/product-category.service'

// Dependencies
import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  metaInfo: {
    title: 'Subcategoria',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_products_categories')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Modal,
    Multiselect,
    Seo,
    TabsStatus,
    FriendlyUrl
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      form: {},
      categoriesOptions: [],
      item: {
        category_id: '',
        title: '',
        title_en: '',
        title_es: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        status: true,
        status_en: false,
        status_es: false,
        main_image: [],
        medias: [],
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        }
      },
      processing: false,
      new: true,
      query: {
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      activeTabIndex: 0,
      redirect: true
    }
  },
  async created() {
    await this.getCategoriesOptions()
    this.setItem()
  },

  methods: {
    async getCategoriesOptions() {
      const response = await CategoryService.index({ pagination: false, sorter: { column: 'title', asc: true } })

      this.categoriesOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })
    },

    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            category_id: data.category_id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            }
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }
      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        category_id: this.form.category_id,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        status: this.form.status,
        status_en: this.form.status_en,
        status_es: this.form.status_es,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Subcategoria de produto foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Subcategoria de produto foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: `${
          response.data.messages.length > 0
              ? response.data.messages[0].message
              : 'Preencha todos os campos corretamente!'
          }`,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
